<template>
  <b-input v-model.lazy="phoneNumber" autocomplete="off" :disabled="$attrs['disabled']" />
</template>

<script>
import { formatPhoneNumber, digitsFromString } from '@/helpers/phoneNumberFormatter'

export default {
  name: 'PhoneNumberInput',
  props: {
    value: {
      type: [Number, String],
      default: () => ''
    }
  },

  created() {
    if (this.value) {
      this.phoneNumberInput = this.value
    }
  },

  data() {
    return {
      phoneNumberInput: null
    }
  },

  computed: {
    phoneNumber: {
      set(newNumber) {
        this.phoneNumberInput = digitsFromString(newNumber)
      },
      get() {
        return formatPhoneNumber(this.phoneNumberInput)
      }
    }
  },

  watch: {
    phoneNumberInput() {
      this.$emit('input', window.parseInt(this.phoneNumberInput))
    },
    value() {
      if (this.phoneNumberInput !== this.value) {
        this.phoneNumberInput = this.value
      }
    }
  }
}
</script>

<style scoped>
</style>
